/* global Highcharts,_ */
(function () {
  'use strict';

  angular.module('wsLrs.directives').run(['wsColors', 'wsConstants', function (wsColors, wsConstants) {
    var vizFontFamily = wsConstants.fontStack.body,
      vizGrayLighter = wsColors.wsGrayLighter,
      vizAxisStyle = {
        color: wsColors.wsGray,
        fontWeight: 500,
        fontFamily: vizFontFamily
      },
      vizAxisTitleStyle = _.extend({
        width: '200px',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      }, vizAxisStyle);
    var vizCol1 = wsColors.vizCol1,
      vizCol2 = wsColors.vizCol2,
      vizCol3 = wsColors.vizCol3,
      vizCol4 = wsColors.vizCol4,
      vizCol5 = wsColors.vizCol5,
      vizCol6 = wsColors.vizCol6,
      vizCol7 = wsColors.vizCol7,
      vizCol8 = wsColors.vizCol8,
      vizCol9 = wsColors.vizCol9,
      vizCol10 = wsColors.vizCol10,
      vizCol11 = wsColors.vizCol11,
      vizCol12 = wsColors.vizCol12,
      vizCol13 = wsColors.vizCol13,
      vizCol14 = wsColors.vizCol14,
      vizCol15 = wsColors.vizCol15;
    Highcharts.SparkLine = function (options, callback) {
      var defaultOptions = {
        chart: {
          renderTo: options.chart && options.chart.renderTo || this,
          backgroundColor: null,
          borderWidth: 0,
          type: 'spline',
          margin: [0, 0, 0, 0],
          width: 75,
          height: 20,
          style: {
            overflow: 'visible'
          },
          skipClone: true
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        xAxis: {
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          startOnTick: false,
          endOnTick: false,
          tickPositions: [],
          lineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: 'transparent',
          minorTickLength: 0,
          tickLength: 0
        },
        yAxis: {
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          endOnTick: false,
          startOnTick: false,
          tickPositions: [],
          // use [0] to create a 0 "baseline"
          lineWidth: 0,
          minorGridLineWidth: 0,
          gridLineColor: 'transparent',
          minorTickLength: 0,
          tickLength: 0
        },
        legend: {
          enabled: false
        },
        tooltip: {
          outside: true,
          enabled: false,
          backgroundColor: null,
          borderWidth: 0,
          shadow: false,
          useHTML: true,
          hideDelay: 0,
          shared: true,
          padding: 0,
          positioner: function positioner(w, h, point) {
            return {
              x: point.plotX - w / 2,
              y: point.plotY - h
            };
          }
        },
        plotOptions: {
          series: {
            allowPointSelect: false,
            animation: false,
            enableMouseTracking: false,
            lineWidth: 1.5,
            marker: {
              enabled: false,
              radius: 1,
              states: {
                hover: {
                  enabled: false
                },
                select: {
                  enabled: false
                }
              }
            },
            shadow: false,
            states: {
              hover: {
                enabled: false
              }
            }
          }
        }
      };
      options = Highcharts.merge(defaultOptions, options);
      return new Highcharts.Chart(options, callback);
    };
    Highcharts.setOptions({
      colors: [vizCol1, vizCol2, vizCol3, vizCol4, vizCol5, vizCol6, vizCol7, vizCol8, vizCol9, vizCol10, vizCol11, vizCol12, vizCol13, vizCol14, vizCol15],
      chart: {
        borderRadius: 5,
        plotBorderColor: vizGrayLighter,
        style: {
          overflow: 'visible',
          fontFamily: vizFontFamily
        }
      },
      lang: {
        noData: "",
        thousandsSep: ','
      },
      title: {
        align: "left",
        useHTML: true
      },
      subtitle: {
        align: "left",
        useHTML: true
      },
      legend: {
        borderRadius: 5,
        borderWidth: 0,
        itemDistance: 20,
        itemMarginTop: 5,
        itemMarginBottom: 5,
        margin: 0,
        symbolRadius: 0,
        symbolHeight: 10,
        symbolWidth: 10,
        useHTML: true,
        enabled: true,
        itemHoverStyle: {
          cursor: 'default'
        },
        itemStyle: {
          cursor: 'default'
        }
      },
      // Defaults for all highcharts' tooltips
      tooltip: {
        animation: true,
        useHTML: true,
        // allows use of css styles for tooltips
        shadow: false,
        borderWidth: 0,
        style: {
          padding: 5
        },
        shape: "callout",
        pointFormat: "<span style=\"color:{series.color}\">\u25CF</span> {series.name}: <b>{point.y:.1f}</b><br/>",
        hideDelay: 100,
        backgroundColor: 'transparent',
        valueDecimals: 2,
        outside: true
      },
      xAxis: {
        tickLength: 0,
        gridLineColor: vizGrayLighter,
        tickColor: vizGrayLighter,
        lineColor: vizGrayLighter,
        title: {
          style: vizAxisTitleStyle
        },
        labels: {
          style: vizAxisStyle
        }
      },
      yAxis: {
        tickLength: 0,
        gridLineColor: vizGrayLighter,
        tickColor: vizGrayLighter,
        lineColor: vizGrayLighter,
        title: {
          style: vizAxisTitleStyle
        },
        labels: {
          style: vizAxisStyle
        }
      },
      plotOptions: {
        series: {
          states: {
            hover: {
              halo: null
            }
          },
          events: {
            legendItemClick: function legendItemClick() {
              return false;
            }
          },
          turboThreshold: 0
        },
        area: {
          turboThreshold: 0
        },
        line: {
          marker: {
            enabled: true // now intelligent guess
          },
          turboThreshold: 2500
        },
        column: {
          crisp: false,
          pointPadding: 0.15,
          groupPadding: 0.1,
          borderWidth: 0,
          turboThreshold: 0
        },
        columnRange: {
          turboThreshold: 0
        },
        bar: {
          crisp: false,
          pointPadding: 0.15,
          groupPadding: 0.1,
          borderWidth: 0,
          turboThreshold: 0
        },
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            style: vizAxisStyle,
            useHTML: true
          },
          point: {
            events: {
              legendItemClick: function legendItemClick(event) {
                event.preventDefault();
              }
            }
          }
        },
        scatter: {
          turboThreshold: 2500
        },
        heatmap: {
          turboThreshold: 0
        }
      }
    });

    // Some other defaults depending on axis orientation
    Highcharts.Axis.prototype.defaultLeftAxisOptions.labels.x = -8; // now -15
    Highcharts.Axis.prototype.defaultRightAxisOptions.labels.x = 8; // now 15
    Highcharts.Axis.prototype.defaultBottomAxisOptions.labels.y = 14; // now 20
    Highcharts.Axis.prototype.defaultTopAxisOptions.labels.y = -5; // now -15
  }]).factory('ChartBuilder', [function () {
    function createSelector(k) {
      return _.isFunction(k) ? k : function (d) {
        return k && d ? d[k] : d;
      };
    }
    function getValueOrMapReduce(value, key, reduce, map) {
      map = map || _.map;
      reduce = reduce || function (v) {
        return v;
      };
      return key ? reduce(map(value, createSelector(key))) : value;
    }
    function getBuilderResult(value) {
      if (value.hasOwnProperty("result") && _.isFunction(value.result)) {
        return value.result();
      } else if (value.hasOwnProperty("_result")) {
        return value._result;
      } else {
        return value;
      }
    }
    var Builder = function Builder(parent, key) {
      this._result = {};
      this._addToParent = function (key) {
        this._parent[key](this);
        return this._parent;
      };
      if (parent) {
        this._parent = parent;
        this.build = _.partial(this._addToParent, key);
      }
      this.options = function addOptions(options) {
        _.extend(this._result, options);
        return this;
      };
      this.result = function getResult() {
        return this._result;
      };
      this._computeAggregate = function (resultKeys, map, value, selector) {
        return this._setField(resultKeys, value, selector, createSelector(selector), map);
      };
      this._addBuilder = function (Builder, field, value, map) {
        if (!value) {
          return new Builder(this, field);
        } else if (!map) {
          var builderResult = getBuilderResult(value);
          if (value._destArray) {
            this._result[field] = this._result[field] || [];
            this._result[field].push(builderResult);
          } else {
            this._result[field] = builderResult;
          }
        } else {
          this._result[field] = _.map(value, function (d) {
            var b = new Builder(this, field);
            map(b, d);
            return getBuilderResult(b);
          });
        }
        return this;
      };
      this._setField = function (resultKeys, value, selector, reduce, map) {
        var cur = this._result,
          currentKey = resultKeys;
        value = getValueOrMapReduce(value, selector, reduce, map);
        if (_.isArray(resultKeys)) {
          currentKey = resultKeys[0];
          for (var i = 0; i < resultKeys.length - 1; i++) {
            if (!_.isObject(cur[currentKey])) {
              cur[currentKey] = {};
            }
            cur = cur[currentKey];
            currentKey = resultKeys[i + 1];
          }
        }
        cur[currentKey] = value;
        return this;
      };
      this._fields = this._fields || [];
      _.each(this._fields, function (fieldName) {
        this[fieldName] = _.partial(this._setField, fieldName);
      }, this);
    };
    var _TitleBuilder = function TitleBuilder(parent, key) {
      if (this.constructor !== _TitleBuilder) {
        return new _TitleBuilder();
      }
      this._fields = ["align", "floating", "margin", "style", "text", "useHTML", "verticalAlign", "x", "y"];
      Builder.call(this, parent, key);
    };
    var _SeriesBuilder = function SeriesBuilder(parent, key) {
      if (this.constructor !== _SeriesBuilder) {
        return new _SeriesBuilder();
      }
      this._fields = ["borderColor", "borderWidth", "color", "data", "dataLabels", "dataParser", "dataURL", "id", "index", "legendIndex", "name", "stack", "type", "xAxis", "yAxis", "zIndex", "enableMouseTracking", "marker"];
      this._destArray = true;
      Builder.call(this, parent, key);
    };
    var _LabelsBuilder = function LabelsBuilder(parent, key) {
      if (this.constructor !== _LabelsBuilder) {
        return new _LabelsBuilder();
      }
      this._fields = ["align", "distance", "enabled", "format", "formatter", "maxStaggerLines", "overflow", "rotation", "staggerLines", "step", "style", "useHTML", "x", "y", "zIndex"];
      Builder.call(this, parent, key);
    };
    var _AxisBuilder = function AxisBuilder(parent, key) {
      if (this.constructor !== _AxisBuilder) {
        return new _AxisBuilder();
      }
      this._fields = ["allowDecimals", "alternateGridColor", "ceiling", "dateTimeLabelFormats", "endOnTick", "floor", "gridLineColor", "gridLineDashStyle", "gridLineWidth", "gridZIndex", "id", "lineColor", "lineWidth", "linkedTo", "maxPadding", "maxZoom", "minPadding", "minRange", "minTickInterval", "minorGridLineColor", "minorGridLineDashStyle", "minorGridLineWidth", "minorTickColor", "minorTickInterval", "minorTickLength", "minorTickPosition", "minorTickWidth", "offset", "opposite", "reversed", "showEmpty", "showFirstLabel", "showLastLabel", "startOfWeek", "startOnTick", "tickColor", "tickInterval", "tickLength", "tickPixelInterval", "tickPosition", "tickPositioner", "tickPositions", "tickWidth", "tickmarkPlacement", "type"];
      this._destArray = true;
      Builder.call(this, parent, key);
      this.title = _.partial(this._addBuilder, _TitleBuilder, "title");
      this.min = _.partial(this._computeAggregate, "min", _.min);
      this.max = _.partial(this._computeAggregate, "max", _.max);
      this.labels = _.partial(this._addBuilder, _LabelsBuilder, "labels");
      this.categories = _.partial(this._setField, "categories");
    };
    var _LegendBuilder = function LegendBuilder(parent, key) {
      if (this.constructor !== _LegendBuilder) {
        return new _LegendBuilder();
      }
      this._fields = ["align", "backgroundColor", "borderColor", "borderRadius", "borderWidth", "enabled", "floating", "itemDistance", "itemHiddenStyle", "itemHoverStyle", "itemMarginBottom", "itemMarginTop", "itemStyle", "itemWidth", "labelFormat", "labelFormatter", "layout", "lineHeight", "margin", "maxHeight", "navigation", "padding", "reversed", "rtl", "shadow", "style", "symbolHeight", "symbolPadding", "symbolRadius", "symbolWidth", "useHTML", "verticalAlign", "width", "x", "y"];
      Builder.call(this, parent, key);
      this.title = _.partial(this._addBuilder, _TitleBuilder, "title");
    };
    var _TooltipBuilder = function TooltipBuilder(parent, key) {
      if (this.constructor !== _TooltipBuilder) {
        return new _TooltipBuilder();
      }
      this._fields = ["animation", "backgroundColor", "borderColor", "borderRadius", "borderWidth", "crosshairs", "dateTimeLabelFormats", "enabled", "followPointer", "followTouchMove", "footerFormat", "formatter", "headerFormat", "hideDelay", "pointFormat", "positioner", "shadow", "shape", "shared", "snap", "style", "useHTML", "valueDecimals", "valuePrefix", "valueSuffix", "xDateFormat"];
      Builder.call(this, parent, key);
    };
    var _NoDataBuilder = function NoDataBuilder(parent, key) {
      if (this.constructor !== _NoDataBuilder) {
        return new _NoDataBuilder();
      }
      this._fields = ["attr", "position", "style"];
      Builder.call(this, parent, key);
    };
    var _EventBuilder = function EventBuilder(parent, key) {
      if (this.constructor !== _EventBuilder) {
        return new _EventBuilder();
      }
      this._fields = ["load", "click"];
      Builder.call(this, parent, key);
    };
    var _ChartBuilder = function ChartBuilder() {
      if (this.constructor !== _ChartBuilder) {
        return new _ChartBuilder();
      }
      Builder.call(this);
      this.title = _.partial(this._addBuilder, _TitleBuilder, "title");
      this.type = _.partial(this._setField, ["chart", "type"]);
      this.subtitle = _.partial(this._addBuilder, _TitleBuilder, "subtitle");
      this.series = _.partial(this._addBuilder, _SeriesBuilder, "series");
      this.axis = _.partial(this._addBuilder, _AxisBuilder);
      this.xAxis = _.partial(this._addBuilder, _AxisBuilder, "xAxis");
      this.yAxis = _.partial(this._addBuilder, _AxisBuilder, "yAxis");
      this.legend = _.partial(this._addBuilder, _LegendBuilder, "legend");
      this.tooltip = _.partial(this._addBuilder, _TooltipBuilder, "tooltip");
      this.plotOptions = _.partial(this._setField, "plotOptions");
      this.colorAxis = _.partial(this._setField, "colorAxis");
      this.borderWidth = _.partial(this._setField, ["chart", "borderWidth"]);
      this.borderRadius = _.partial(this._setField, ["chart", "borderRadius"]);
      this.borderColor = _.partial(this._setField, ["chart", "borderColor"]);
      this.events = _.partial(this._setField, ["chart", "events"]);
      this.margin = _.partial(this._setField, ["chart", "margin"]);
      this.spacing = _.partial(this._setField, ["chart", "spacing"]);
    };
    return _ChartBuilder;
  }]).directive('highchart', ["$timeout", function ($timeout) {
    return {
      restrict: 'A',
      template: '<div class="full-height"></div>',
      scope: {
        chartData: "=value",
        onComplete: "&?onComplete",
        chartObj: "=?",
        height: "=",
        width: "="
      },
      transclude: true,
      replace: true,
      link: function link($scope, $element, $attrs) {
        var chartsDefaults = {
          chart: {
            renderTo: $element[0],
            type: $attrs.type || null,
            height: $scope.height || null,
            width: $scope.width || null
          },
          credits: {
            enabled: false
          }
        };
        if ($scope.$root.customCardCssUrl) {
          chartsDefaults.styledMode = true;
        }

        //Update when charts data changes
        $scope.$watch(function () {
          return $scope.chartData;
        }, function (value) {
          if (!value) {
            return;
          }

          // show "loading..." overlay
          if ($scope.chartObj) {
            var loading = $scope.chartObj.options.loading;
            loading.labelStyle.position = 'relative';
            loading.labelStyle.top = '20px';
            loading.style.opacity = 0.7;
            $scope.chartObj.showLoading("Loading...");
          }

          // When there are other things being rendered around the chart (like duration bullets),
          // the containing element may not have the final width yet.  Wrap in timeout to allow
          // the other elements to render first.
          $timeout(function () {
            // We need deep copy in order to NOT override original chart object.
            // This allows us to override chart data member and still the keep
            // our original renderTo will be the same
            var deepCopy = true;
            var newSettings = {};
            $.extend(deepCopy, newSettings, chartsDefaults, $scope.chartData);
            if (!$scope.onComplete) {
              $scope.chartObj = new Highcharts.Chart(newSettings);
            } else {
              $scope.chartObj = new Highcharts.Chart(newSettings, $scope.onComplete());
            }
          }, 0);
        }, true // Indicates a deep watch we pick up changes in series
        );
      }
    };
  }]).
  // This directive allows us to use the jQuery Sparkline lib via angular.
  // http://http://omnipotent.net/jquery.sparkline
  // ex:
  //  <div ws-sparkline
  //      ng-model="arrayOfData"
  //      opts="{{ { type: 'line', fillColor: false, lineColor: '#4891DF'} }}"
  //   </div>
  //
  directive('wsSparkline', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        chartObj: "=?"
      },
      link: function link($scope, $element, $attrs, ngModel) {
        var settings = {
          chart: {
            renderTo: $element[0],
            type: $attrs.type || 'line'
          },
          credits: {
            enabled: false
          }
        };
        $scope.$watch($attrs.ngModel, function () {
          render();
        }, true);
        $scope.$watch($attrs.opts, function () {
          render();
        });
        var render = function render() {
          var model;
          if ($attrs.opts) {
            angular.extend(settings, angular.fromJson($attrs.opts));
          }
          // Trim trailing comma if we are a string
          if (angular.isString(ngModel.$viewValue)) {
            model = ngModel.$viewValue.replace(/(^,)|(,$)/g, "");
          } else {
            model = ngModel.$viewValue;
          }
          var data = angular.isArray(model) ? model : model.split(',');
          angular.extend(settings, {
            series: [{
              data: data
            }]
          });
          $scope.chartObj = new Highcharts.SparkLine(settings);
        };
      }
    };
  });
})();
